import { Box } from "@mui/material";
import React from "react";

import { monospaceStyle } from "../../theme";

export interface ShareBarProps {
  // How many of the whole
  count: number;
  // The whole the count is out of. Without it only the count is shown.
  total?: number | null;
  // What is counted, for a screen reader, e.g. "products"
  noun?: string;
}

/**
 * A count out of a whole: "12 of 41" in digits of equal width, beside a thin
 * bar filled to that share.
 */
const ShareBar: React.FC<ShareBarProps> = ({ count, total, noun }) => {
  const whole = typeof total === "number" && total > 0 ? total : null;
  const share = whole === null ? 0 : Math.min(1, Math.max(0, count / whole));
  const text = whole === null ? String(count) : `${count} of ${whole}`;

  return (
    <Box
      component="span"
      aria-label={noun ? `${text} ${noun}` : text}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 1,
        whiteSpace: "nowrap",
      }}
    >
      {whole !== null && (
        <Box
          component="span"
          aria-hidden
          sx={{
            display: "inline-block",
            width: 64,
            height: 4,
            borderRadius: "2px",
            backgroundColor: "divider",
            overflow: "hidden",
          }}
        >
          <Box
            component="span"
            sx={{
              display: "block",
              width: `${share * 100}%`,
              height: "100%",
              backgroundColor: "primary.main",
            }}
          />
        </Box>
      )}
      <Box
        component="span"
        sx={{ ...monospaceStyle, fontSize: "0.75rem", color: "text.secondary" }}
      >
        {text}
      </Box>
    </Box>
  );
};

export default ShareBar;
